/**
 * Links into the Forward merchant portal.
 *
 * Disputes are read-only here: a chargeback is answered in Forward's own
 * portal, and the outcome comes back on the next sync. These links are how
 * staff get from a dispute they can see to the place they can act on it,
 * without hunting for the address.
 *
 * One module so the list button and the per-dispute links cannot drift apart.
 */

/** The practice-facing Forward portal, white-labelled onto our own domain. */
const FORWARD_PORTAL_BASE_URL = 'https://payportal.followthatpatient.com';

/** The dispute list in the Forward portal. */
export const FORWARD_PORTAL_DISPUTES_URL = `${FORWARD_PORTAL_BASE_URL}/disputes`;

/**
 * One dispute's page in the Forward portal.
 *
 * `disputeId` is Forward's own id (`dp_…`), which is what DisputeRow.id already
 * holds — the portal keys on the same value, so nothing extra is needed from
 * our API.
 */
export function forwardDisputeUrl(disputeId: string): string {
  return `${FORWARD_PORTAL_DISPUTES_URL}/${encodeURIComponent(disputeId)}`;
}
